import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { resolveSchemaWithRef } from '../utils';
import { SchemaDefinitionsContext } from './SchemaDefinitionsProvider';
export const SchemaContext = createContext({ schema: {}, definitions: {} });
export const SchemaProvider = ({ schema, children }) => {
    const { definitions, omitFields } = useContext(SchemaDefinitionsContext);
    const value = useMemo(() => {
        const resolvedSchema = resolveSchemaWithRef(schema, definitions);
        if (Array.isArray(resolvedSchema.anyOf)) {
            resolvedSchema.anyOf = resolvedSchema.anyOf.map((anyOfSchema) => resolveSchemaWithRef(anyOfSchema, definitions));
        }
        if (Array.isArray(resolvedSchema.oneOf)) {
            resolvedSchema.oneOf = resolvedSchema.oneOf.map((oneOfSchema) => resolveSchemaWithRef(oneOfSchema, definitions));
        }
        omitFields.forEach((field) => {
            var _a;
            (_a = resolvedSchema.properties) === null || _a === void 0 ? true : delete _a[field];
        });
        return { schema: resolvedSchema, definitions };
    }, [definitions, omitFields, schema]);
    return _jsx(SchemaContext.Provider, { value: value, children: children });
};
//# sourceMappingURL=SchemaProvider.js.map